import { nanoid } from 'nanoid';
import { getDB } from '../storage/db';
import { sortByDateAddedDesc } from '../utils/sort';
export async function list() {
    const db = await getDB();
    const items = await db.getAll('inventory');
    return sortByDateAddedDesc(items);
}
export async function create(quantityBags, status = 'ordered', dateArrived) {
    if (!Number.isFinite(quantityBags) || quantityBags <= 0) {
        throw new Error('Quantity must be a positive number');
    }
    const now = new Date().toISOString();
    const item = {
        id: nanoid(),
        quantityBags,
        status,
        dateAdded: now,
        dateArrived: status === 'arrived' ? dateArrived ?? now.slice(0, 10) : null,
    };
    const db = await getDB();
    await db.put('inventory', item);
    return item;
}
export async function update(item) {
    if (!Number.isFinite(item.quantityBags) || item.quantityBags <= 0) {
        throw new Error('Quantity must be a positive number');
    }
    const db = await getDB();
    await db.put('inventory', item);
}
export async function remove(id) {
    const db = await getDB();
    await db.delete('inventory', id);
}
export async function arrive(id, arrivalDate) {
    const db = await getDB();
    const item = await db.get('inventory', id);
    if (!item)
        return null;
    item.status = 'arrived';
    item.dateArrived = arrivalDate ?? new Date().toISOString().slice(0, 10);
    await db.put('inventory', item);
    return item;
}
export async function clear() {
    const db = await getDB();
    await db.clear('inventory');
}
